// Iterates current step index

const TerminateSessionActions = {
  TERMINATE_SESSION: 'TerminateSession.TERMINATE_SESSION',
};

export default TerminateSessionActions;
